"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHotelData = void 0;
var _react = require("react");
var _helpers = require("../helpers");
var useHotelData = _ref => {
  var {
    currentDates,
    currentStartDate,
    data,
    isLoading,
    isError
  } = _ref;
  var [hotelData, setHotelData] = (0, _react.useState)([]);
  var [sortedByDate, setSortedByDate] = (0, _react.useState)(null);
  var [globalLowestPrice, setGlobalLowestPrice] = (0, _react.useState)(null);
  (0, _react.useEffect)(() => {
    if (data && !isLoading && !isError) {
      var _typedData$getLowestR, _typedData$getLowestR2;
      var typedData = data;
      var apiData = (typedData === null || typedData === void 0 || (_typedData$getLowestR = typedData.getLowestRatesByLocationId) === null || _typedData$getLowestR === void 0 ? void 0 : _typedData$getLowestR.priceFinderOperaHotelAvailabilitiesDtoList) || [];
      var transformedData = (0, _helpers.transformApiDataToHotelPrices)(apiData, currentDates);
      setHotelData(transformedData);
      var lowestMonthlyRate = (typedData === null || typedData === void 0 || (_typedData$getLowestR2 = typedData.getLowestRatesByLocationId) === null || _typedData$getLowestR2 === void 0 || (_typedData$getLowestR2 = _typedData$getLowestR2.lowestMonthlyRate) === null || _typedData$getLowestR2 === void 0 ? void 0 : _typedData$getLowestR2.price) || null;
      setGlobalLowestPrice(lowestMonthlyRate);
    }
    setSortedByDate(null);
  }, [currentStartDate, data, isLoading, isError, currentDates]);
  var handleDateSort = (0, _react.useCallback)(clickedDate => {
    var dateIndex = currentDates.indexOf(clickedDate);
    if (dateIndex === -1) return;
    setHotelData(prevData => {
      var sortedHotels = [...prevData].sort((a, b) => {
        var _a$prices$dateIndex, _b$prices$dateIndex;
        var priceA = (_a$prices$dateIndex = a.prices[dateIndex]) === null || _a$prices$dateIndex === void 0 ? void 0 : _a$prices$dateIndex.amount;
        var priceB = (_b$prices$dateIndex = b.prices[dateIndex]) === null || _b$prices$dateIndex === void 0 ? void 0 : _b$prices$dateIndex.amount;
        if (priceA === null && priceB === null) return 0;
        if (priceA === null) return 1;
        if (priceB === null) return -1;
        return priceA - priceB;
      });
      return sortedHotels;
    });
    setSortedByDate(clickedDate);
  }, [currentDates]);
  return {
    hotelData,
    sortedByDate,
    globalLowestPrice,
    handleDateSort,
    setHotelData
  };
};
exports.useHotelData = useHotelData;